import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
import type { GPTStore } from "@/ts/types";
export const initialState = {
    slotConfigsGroup: [
        {
            commandId: -1,
            slotConfigs: [],
        },
    ],
    slotsGroup: [
        {
            slots: {},
            commandId: -1,
        },
    ],
    slotSizes: {},
    slotsTemplate: {
        targeting: {
            hivis: "",
            mantis_placement: "",
        },
    },
    pageAdUnitPath: "",
    enforceSRA: false,
    usePageAdUnitPathForCarousel: false,
};
export const gptStore = createStore<GPTStore>()(devtools(subscribeWithSelector(immer((set, get) => ({
    ...initialState,
    actions: {
        addAdUnitPath: (unitPath: string) => set((state) => {
            state.pageAdUnitPath = unitPath;
        }),
        setSlotConfigsByCommandId: (commandId: number, newSlotConfigs) => set((state) => {
            state.slotConfigsGroup = [
                ...state.slotConfigsGroup,
                { commandId, slotConfigs: newSlotConfigs },
            ];
        }),
        setSlotsByCommandId: (commandId: number, newSlots: Record<string, googletag.Slot>) => set((state) => {
            state.slotsGroup = [
                ...state.slotsGroup,
                { commandId, slots: newSlots },
            ];
        }),
    },
    selectors: {
        getSlotConfigs: () => {
            return (get().slotConfigsGroup.flatMap((entry) => entry.slotConfigs) ?? []);
        },
        getUpdatedSlotConfigs: () => {
            const slotConfigsGroup = get().slotConfigsGroup;
            return Array.isArray(slotConfigsGroup) &&
                slotConfigsGroup.length > 0
                ? slotConfigsGroup.slice(-1)
                : [];
        },
        getSlotConfigsByCommandId: (commandId: number) => {
            return (get().slotConfigsGroup?.find((entry) => entry.commandId === commandId)?.slotConfigs ?? []);
        },
        getSlotsByCommandId: (commandId: number) => {
            return (get().slotsGroup?.find((entry) => entry.commandId === commandId)
                ?.slots ?? {});
        },
        getSlotConfigsByCommandIdAndSlotId: (commandId: number, slotId: string) => {
            const group = get().slotConfigsGroup.find((entry) => entry.commandId === commandId);
            return (group?.slotConfigs.filter((config) => config.slotId === slotId) ??
                []);
        },
        getPageAdUnitPath: () => get().pageAdUnitPath,
    },
}))), {
    name: "Hydra-GPTStore",
}));
